export default [
  {
    id: "c1",
    title: "Backlog",
    tasks: [
      {
        id: "t1",
        title: "Second Task",
        content: "Mollit et veniam velit dolor reprehenderit nisi commodo."
      },
      {
        id: "t2",
        title: "Third Task",
        content:
          "Nostrud aute ex eu ullamco in voluptate do excepteur exercitation."
      }
    ]
  },
  {
    id: "c2",
    title: "Daily",
    tasks: [
      {
        id: "t0",
        title: "First Task",
        content: "Aliquip nulla sit minim sunt cillum nisi."
      }
    ]
  },
  {
    id: "c3",
    title: "Working",
    tasks: []
  },
  {
    id: "c4",
    title: "Done",
    tasks: []
  },
  {
    id: "c5",
    title: "Archived",
    tasks: []
  }
];
